export function setPlans(state, payload) {
  let response = []
  payload.forEach(element => {
    element['img'] = 'modules-0' + element.Order
    response.push(element)
  })
  state.planInfo = response
}
export function setOptions(state, payload) {
  state.options = payload
}